import { render, staticRenderFns } from "./update-position.vue?vue&type=template&id=2bff15d8&scoped=true"
import script from "./update-position.vue?vue&type=script&lang=js"
export * from "./update-position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff15d8",
  null
  
)

export default component.exports